import { combineLatest, ObservableInput } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

export const anyTrue = (...observables: Array<ObservableInput<boolean>>) =>
  combineLatest(observables).pipe(
    map((values) => values.some((v) => v === true)),
    distinctUntilChanged()
  );
